// dashboard-agent-ia/src/pages/Contact.js
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export default function Contact() {
  const [form, setForm] = useState({ nom: '', email: '', telephone: '', sujet: '', message: '' })
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!form.nom || !form.email || !form.message) { setError('Veuillez remplir tous les champs obligatoires.'); return }
    setSending(true); setError('')
    try {
      // Envoyer vers un webhook ou email service
      await fetch('https://formsubmit.co/ajax/lebinaire@gmail.com', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          name: form.nom,
          email: form.email,
          phone: form.telephone,
          subject: form.sujet,
          message: form.message,
          _subject: `Contact Agent IA — ${form.sujet || form.nom}`,
        })
      })
      setSent(true)
    } catch (e) { setError('Erreur envoi. Contactez-nous directement sur WhatsApp.') }
    finally { setSending(false) }
  }

  const BLUE = '#3b82f6'

  return (
    <div style={{ background: 'linear-gradient(135deg,#0f172a,#1e1b4b,#0f172a)', minHeight: '100vh', color: 'white', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>

      {/* Nav */}
      <nav style={{ padding: '0 clamp(16px,4vw,40px)', height: 68, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: `linear-gradient(135deg,${BLUE},#1d4ed8)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🤖</div>
          <span style={{ fontWeight: 800, fontSize: 18, color: 'white' }}>Agent <span style={{ color: BLUE }}>IA</span> Sénégal</span>
        </Link>
        <Link to="/" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: 14 }}>← Retour</Link>
      </nav>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: 'clamp(40px,6vw,80px) clamp(16px,5vw,40px)', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 40, alignItems: 'start' }}>

        {/* Infos contact */}
        <div>
          <p style={{ color: BLUE, fontSize: 13, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Contact</p>
          <h1 style={{ fontSize: 48, fontWeight: 800, letterSpacing: '-2px', marginBottom: 20, lineHeight: 1.1 }}>
            Parlons de votre projet
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 17, lineHeight: 1.7, marginBottom: 48 }}>
            Une question sur Agent IA ? Vous voulez une démo personnalisée ? Notre équipe vous répond sous 24h.
          </p>

          {[
            { icon: '📞', label: 'WhatsApp', value: '+221 77 648 00 68', href: 'https://wa.me/221776480068' },
            { icon: '✉️', label: 'Email', value: 'lebinaire@gmail.com', href: 'mailto:lebinaire@gmail.com' },
            { icon: '📍', label: 'Adresse', value: 'Dakar, Sénégal', href: null },
            { icon: '🕐', label: 'Disponibilité', value: 'Lun–Sam, 8h–20h', href: null },
          ].map((item, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
              <div style={{ width: 48, height: 48, borderRadius: 14, background: `rgba(59,130,246,0.1)`, border: `1px solid rgba(59,130,246,0.2)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
                {item.icon}
              </div>
              <div>
                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12, marginBottom: 2 }}>{item.label}</p>
                {item.href
                  ? <a href={item.href} style={{ color: 'white', fontWeight: 600, fontSize: 16, textDecoration: 'none' }}>{item.value}</a>
                  : <p style={{ color: 'white', fontWeight: 600, fontSize: 16 }}>{item.value}</p>
                }
              </div>
            </div>
          ))}

          {/* WhatsApp CTA */}
          <a href="https://wa.me/221776480068?text=Bonjour, je souhaite en savoir plus sur Agent IA"
            target="_blank" rel="noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 10, background: '#25d366', color: 'white', padding: '14px 28px', borderRadius: 12, textDecoration: 'none', fontWeight: 700, fontSize: 15, marginTop: 16 }}>
            💬 Écrire sur WhatsApp
          </a>
        </div>

        {/* Formulaire */}
        <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 24, padding: 40 }}>
          {sent ? (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <div style={{ fontSize: 64, marginBottom: 20 }}>✅</div>
              <h2 style={{ fontSize: 28, fontWeight: 800, marginBottom: 12 }}>Message envoyé !</h2>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 16 }}>Nous vous répondrons sous 24h. Merci !</p>
              <button onClick={() => { setSent(false); setForm({ nom:'',email:'',telephone:'',sujet:'',message:'' }) }}
                style={{ marginTop: 24, background: BLUE, color: 'white', border: 'none', padding: '12px 28px', borderRadius: 10, fontWeight: 700, cursor: 'pointer', fontSize: 15 }}>
                Envoyer un autre message
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 28 }}>Envoyer un message</h2>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginBottom: 16 }}>
                {[
                  { key: 'nom', label: 'Nom complet *', placeholder: 'Moussa Diallo' },
                  { key: 'email', label: 'Email *', placeholder: 'moussa@example.com', type: 'email' },
                ].map(f => (
                  <div key={f.key}>
                    <label style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: 8 }}>{f.label}</label>
                    <input type={f.type || 'text'} value={form[f.key]} onChange={e => setForm(p => ({...p, [f.key]: e.target.value}))}
                      placeholder={f.placeholder} required={f.label.includes('*')}
                      style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 16px', color: 'white', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}/>
                  </div>
                ))}
              </div>
              {[
                { key: 'telephone', label: 'Téléphone', placeholder: '+221 77 000 00 00' },
                { key: 'sujet', label: 'Sujet', placeholder: 'Demande de démo, Question tarif...' },
              ].map(f => (
                <div key={f.key} style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: 8 }}>{f.label}</label>
                  <input value={form[f.key]} onChange={e => setForm(p => ({...p, [f.key]: e.target.value}))}
                    placeholder={f.placeholder}
                    style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 16px', color: 'white', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}/>
                </div>
              ))}
              <div style={{ marginBottom: 24 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: 8 }}>Message *</label>
                <textarea value={form.message} onChange={e => setForm(p => ({...p, message: e.target.value}))}
                  placeholder="Décrivez votre projet ou votre question..." required rows={5}
                  style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 16px', color: 'white', fontSize: 14, outline: 'none', resize: 'vertical', boxSizing: 'border-box' }}/>
              </div>
              {error && <p style={{ color: '#f87171', fontSize: 14, marginBottom: 16 }}>{error}</p>}
              <button type="submit" disabled={sending}
                style={{ width: '100%', background: `linear-gradient(135deg,${BLUE},#1d4ed8)`, color: 'white', border: 'none', padding: '16px', borderRadius: 12, fontWeight: 700, fontSize: 16, cursor: sending ? 'not-allowed' : 'pointer', opacity: sending ? 0.7 : 1, boxShadow: '0 8px 24px rgba(59,130,246,0.3)' }}>
                {sending ? 'Envoi en cours...' : '🚀 Envoyer le message'}
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: 'clamp(20px,4vw,40px)', textAlign: 'center' }}>
        <p style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13 }}>© 2025 Agent IA Sénégal by LeBinaire · <Link to="/conditions" style={{ color: 'rgba(255,255,255,0.3)', textDecoration: 'none' }}>Conditions</Link> · <Link to="/confidentialite" style={{ color: 'rgba(255,255,255,0.3)', textDecoration: 'none' }}>Confidentialité</Link></p>
      </footer>
    </div>
  )
}
